import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { HomeOutlined } from '@ant-design/icons';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    }}>
      <Result
        status="404"
        title="404"
        subTitle="عذراً، الصفحة التي تبحث عنها غير موجودة."
        extra={
          <Button 
            type="primary" 
            icon={<HomeOutlined />}
            onClick={() => navigate('/')}
            size="large"
          >
            العودة للصفحة الرئيسية
          </Button>
        }
        style={{
          background: 'rgba(255,255,255,0.95)',
          borderRadius: 20,
          padding: 40,
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        }}
      />
    </div>
  );
};

export default NotFound;
